import $ from "jquery";
import "slick-carousel";
// import 'arrive';
// import { gsap } from "gsap";
// import { ScrollTrigger } from "../lib/ScrollTrigger.min";

$(document).ready(function () {
  $(".srg-slick-image-slider").each(function () {
    let $slider = $(this);
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      speed: 500,
      fade: true,
      cssEase: "linear",
    });
    $slider.on("afterChange", function (event, slick, currentSlide) {
      $slider
        .parents(".block-history-block-container")
        .find(".srg-slider-counter .counter")
        .html(++currentSlide);
    });
  });

  // let $history = $('.block-history-blocks');
  let $timeline = $("#srg-timeline");
  if ($timeline.length) {
    function selectYear($target) {
      $target.parent().addClass("active").prevAll("div").addClass("active");
      $target.parent().nextAll("div").removeClass("active");
      if ($target && $target.position()) {
        var pos =
          $target.offset().left +
          $target.outerWidth(true) / 2 +
          $timeline.scrollLeft() -
          $timeline.width() / 2;
        $timeline.animate({
          scrollLeft: pos - 15,
        });
      }
    }
    function hashChange() {
      let current_href = "#" + window.location.href.split("#")[1];
      selectYear($('.year-btn[data-target="' + current_href + '"]'));
    }
    hashChange();

    window.addEventListener("hashchange", function () {
      hashChange();
    });
    let $timeline_offsetTop = $timeline.position().top;
    let $header_height = $("header").outerHeight();
    let $years = $(".year-btn");

    // window.onscroll = function() {scrollHistory()};
    // function scrollHistory() {
    //     if (window.pageYOffset >= $timeline_offsetTop - $header_height) {
    //         $history.addClass("sticky");
    //     } else {
    //         $history.removeClass("sticky");
    //     }
    // }

    $years.each(function () {
      let $btn = $(this);
      $btn.click(function () {
        let dest_selector = $btn.attr("data-target");
        // let dest = $(dest_selector).position().top;
        // window.scrollTo({top: dest - $header_height - $timeline.outerHeight(), behavior: 'smooth'});
        selectYear($(this));
        window.location.href = dest_selector;
      });
    });

    let isDown = false;
    let startX;
    let scrollLeft;
    $timeline.on("mousedown", function (e) {
      isDown = true;
      $timeline.addClass("active");
      startX = e.pageX - $timeline[0].offsetLeft;
      scrollLeft = $timeline[0].scrollLeft;
    });
    $timeline.on("mouseleave", function () {
      isDown = false;
      $timeline.removeClass("active");
    });
    $timeline.on("mouseup", () => {
      isDown = false;
      $timeline.removeClass("active");
    });
    $timeline.on("mousemove", function (e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - $timeline[0].offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      $timeline[0].scrollLeft = scrollLeft - walk;
    });
  }

  // gsap.registerPlugin(ScrollTrigger);
  //
  // document.arrive('.block-history-block-container', {existing: true}, function(){
  //     let timeline_year = '.year-btn[data-target="#'+$(this).attr('id')+'"]';
  //     let img_slider = $(this).find('.srg-slick-image-slider');
  //     let img_single_box = $(this).find('.srg-single-image-box');
  //     let scrollTrigger = {
  //         trigger: this,
  //         start: 'top bottom-=50%',
  //         end: 'bottom bottom-=50%',
  //         toggleActions: 'play reset play reset',
  //         // markers: true,
  //         onEnter: () => {
  //             $(timeline_year).parent().addClass('active').prevAll('div').addClass('active');
  //         },
  //         onLeaveBack: () => {
  //             $(timeline_year).parent().removeClass('active').nextAll('div').removeClass('active');
  //         },
  //     }
  //     if(img_slider.length) {
  //         gsap.from(img_slider[0], {
  //             autoAlpha: 0,
  //             duration: 0.5,
  //             scrollTrigger: scrollTrigger
  //         });
  //     } else {
  //         if(img_single_box.length) {
  //             gsap.from(img_single_box[0],{
  //                 autoAlpha: 0,
  //                 duration: 0.5,
  //                 scrollTrigger: scrollTrigger
  //             });
  //         } else {
  //             gsap.from($(this).find('.block-history-block-gallery'),{
  //                 autoAlpha: 1,
  //                 scrollTrigger: scrollTrigger
  //             });
  //         }
  //     }
  // });
});

function fixTimeline(origin, direction) {
  let $timeline = $('#srg-timeline');
  if ($timeline.length && origin.index == 0 && direction == 'down') {
    $('body').addClass('sticky-timeline');
  } else if (origin.index == 1 && direction == 'up') {
    $('body').removeClass('sticky-timeline');
  }
}

export default {
  fixTimeline
}